import {
  useMutationAppointmentBookingConsumeSessions,
  useMutationAppointmentBookingCustomPaymentByCustomPaymentCategoryId,
  useMutationAppointmentBookingPaymentByPaymentMethodId,
} from "@gymflow/api";
import { CustomPaymentCategoryDTO } from "@gymflow/types";
import useGymflowModels from "apps/portal/src/store";

import { PaymentUnitType } from "../SideBarAppointment";

type HandleAppointmentPaymentParams = {
  appointmentId: number;
  paymentUnit: PaymentUnitType;
  paymentMethodId?: string;
  promotionCode?: string;
  inPersonPaymentMethod?: { value: CustomPaymentCategoryDTO };
};

export const useHandleAppointmentPayment = () => {
  const { api } = useGymflowModels();

  const { mutateAsync: payOnline } =
    useMutationAppointmentBookingPaymentByPaymentMethodId({ api });
  const { mutateAsync: payWithCredits } =
    useMutationAppointmentBookingConsumeSessions({ api });
  const { mutateAsync: payCustom } =
    useMutationAppointmentBookingCustomPaymentByCustomPaymentCategoryId({
      api,
    });

  const handlePayment = async ({
    appointmentId,
    paymentUnit,
    paymentMethodId,
    promotionCode,
    inPersonPaymentMethod,
  }: HandleAppointmentPaymentParams): Promise<{
    invoiceNumber?: string;
  }> => {
    if (paymentUnit === "ONLINE" && paymentMethodId) {
      return await payOnline({
        appointmentId,
        paymentMethodId,
        promotionCode,
      });
    }

    if (paymentUnit === "CREDITS") {
      await payWithCredits({ appointmentId, promotionCode });
      // without response (204 code)
      return {};
    }

    if (paymentUnit === "IN_PERSON" && inPersonPaymentMethod) {
      return await payCustom({
        appointmentId,
        customPaymentCategoryId: inPersonPaymentMethod.value.id,
        promotionCode,
      });
    }

    return {};
  };

  return { handlePayment };
};
